exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[data-v-d0aad71a]:disabled {\n    background-color: #efefef !important;\n}\n\n", ""]);

// exports
